import React, { Component } from 'react';

import { delegateHover } from '../utils';

import UrlPreview from './url-preview';
import Popout from './popout';

export default class AnchorUrlPreview extends Component {
    constructor(props) {
        super(props);

        this.unbindHover = null;
        this.popoutCtrl = null;
        this.state = {
            url: null
        };
    }

    show(element) {
        const handleMouseOut = () => {
            this.popoutCtrl && this.popoutCtrl.hide();

            this.setState({
                url: null
            });

            element.removeEventListener('mouseout', handleMouseOut);
        }

        this.setState({
            url: element.href
        }, () => {
            this.popoutCtrl && this.popoutCtrl.show().then(() => {
                this.popoutCtrl.setOverlayParentElement(element);
            });
        });

        element.addEventListener('mouseout', handleMouseOut);
    }

    componentDidMount() {
        this.unbindHover = delegateHover(document, 'link-for-preview-url', event => {
            this.show(event.target);
        });
    }

    componentWillUnmount() {
        this.unbindHover && this.unbindHover();
    }

    render() {
        return (
            <Popout provideController={ctrl => this.popoutCtrl = ctrl} className="auto-size">
                <UrlPreview url={this.state.url} />
            </Popout>
        )
    }
}
